import React, { useEffect, useState } from "react";
import { QrCode } from "lucide-react";

export default function LiveStandingsQrDownload({ match, family }) {
  const matchId = String(match.matchId || "").trim();
  const key = `${family}:${matchId}`;
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const current = result?.key === key ? result : null;
  const name = String(match.matchName || "match").normalize("NFKD")
    .replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 100) || "match";

  useEffect(() => {
    let cancelled = false;
    async function prepare() {
      try {
        if (!matchId || !["arc", "bullseye"].includes(family)) throw new Error("Missing match link");
        // Printed QR codes must open the public match, not localhost or a viewer's filters.
        const url = `https://www.armorysync.com/matches/${family}/${encodeURIComponent(matchId)}`;
        const { default: QRCode } = await import("qrcode");
        const image = await QRCode.toDataURL(url, {
          type: "image/png", width: 1024, margin: 4, errorCorrectionLevel: "M",
          color: { dark: "#000000ff", light: "#ffffffff" },
        });
        if (!cancelled) setResult({ key, image });
      } catch {
        if (!cancelled) setResult({ key, error: "QR export failed. Please try again." });
      }
    }
    prepare();
    return () => { cancelled = true; };
  }, [family, matchId, key, retry]);

  return <div className="live-qr-download">
    {current?.image ? <a className="live-refresh" href={current.image} download={`${name}-qr-code.png`}
      title="Download the public match QR code as a PNG image"><QrCode size={16} aria-hidden="true" />Export QR PNG</a>
      : <button className="live-refresh" type="button" disabled={!current?.error} aria-busy={!current?.error}
        onClick={() => { setResult(null); setRetry(value => value + 1); }}>
        <QrCode size={16} aria-hidden="true" />{current?.error ? "Retry QR export" : "Creating PNG..."}
      </button>}
    {current?.error && <p className="live-qr-error" role="alert">{current.error}</p>}
  </div>;
}
